//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebsiteBlockInputItem } from './WebsiteBlockInputItem';

export class WebsitePageInputItem extends ItemBase {
    Description: string | null = null;
    InMenu: boolean = false;
    Keywords: string[] = [];
    OrderIndex: number = 0;
    RobotsIndex: boolean = false;
    SEOTitle: string | null = null;
    Title: string | null = null;
    IsHomepage: boolean = false;
    ChildWebsitePages: WebsitePageInputItem[] = [];
    WebsiteBlocks: WebsiteBlockInputItem[] = [];

    constructor(initializer?: Partial<WebsitePageInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebsitePageInputItem";
}
